import { ChangeDetectionStrategy, Component, model, ViewChild } from '@angular/core';
import { NgbModalConfig, NgbModal, NgbModule } from '@ng-bootstrap/ng-bootstrap';
import { ToastrService } from 'ngx-toastr';
import { NotificationService } from '../../../../core/services/notification.service';
import { ProgramService } from '../../../../core/services/program.service';
import { AppErrorShow } from '../../../../core/utils/app-error-show';
import { LocalStorageService } from '../../../../core/utils/local-stoarge-service';
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';
import { NgSelectModule } from '@ng-select/ng-select';
import { SampleSearchPipe } from '../../../../core/pipes/sample-search.pipe';
import { LoadingComponent } from '../../../components/loading/loading.component';
import { HeaderComponent } from '../../../admin/layout/includes/header/header.component';
import { TimeTableItemComponent } from '../../../components/time-table-item/time-table-item.component';
import { AgendaItemComponent } from '../../../components/agenda-item/agenda-item.component';
import { RappelItemComponent } from '../../../components/rappel-item/rappel-item.component';
import { InformationItemComponent } from '../../../components/information-item/information-item.component';
import {MatCardModule} from '@angular/material/card';
import {MatDatepickerModule} from '@angular/material/datepicker';
import { BaseChartDirective } from 'ng2-charts';
import { ChartConfiguration, ChartOptions } from 'chart.js';
import { GlobalName } from '../../../../core/utils/global-name';

@Component({
    selector: 'app-home',
    templateUrl: './home.component.html',
    imports: [
        TimeTableItemComponent,
        AgendaItemComponent,
        RappelItemComponent,
        InformationItemComponent,
        MatCardModule,
        MatDatepickerModule,
        BaseChartDirective,
        CommonModule, FormsModule, NgbModule, LoadingComponent, SampleSearchPipe, HeaderComponent, NgSelectModule
    ],
    styleUrls: ['./home.component.css'],
    changeDetection: ChangeDetectionStrategy.OnPush
})
export class HomeComponent {
  @ViewChild('addContent') addContent: any
  data:any[] =[]
  agendas:any[] =[]
  rappels:any[] =[]
  userfuls:any[] =[]
  rappelSelected:any
  tag="professors-accueil"
  selected = model<Date | null>(null);


  public barChartLegend = true;
  public barChartPlugins = [];

  public barChartData: ChartConfiguration<'bar'>['data'] = {
    labels: [ '2006', '2007', '2008', '2009', '2010', '2011', '2012' ],
    datasets: [
      { data: [ 65, 59, 80, 81, 56, 55, 40 ], label: 'Series A' },
      { data: [ 28, 48, 40, 19, 86, 27, 90 ], label: 'Series B' }
    ]
  };

  public barChartOptions: ChartConfiguration<'bar'>['options'] = {
    responsive: false,
  };


  // Pie
  public pieChartOptions: ChartOptions<'pie'> = {
    responsive: false,
  };
  public pieChartLabels = [ [ 'Download', 'Sales' ], [ 'In', 'Store', 'Sales' ], 'Mail Sales' ];
  public pieChartDatasets = [ {
    data: [ 300, 500, 100 ]
  } ];
  public pieChartLegend = true;
  public pieChartPlugins = [];



  public lineChartData: ChartConfiguration<'line'>['data'] = {
    labels: [
      'January',
      'February',
      'March',
      'April',
      'May',
      'June',
      'July'
    ],
    datasets: [
      {
        data: [ 65, 59, 80, 81, 56, 55, 40 ],
        label: 'Series A',
        fill: true,
        tension: 0.5,
        borderColor: 'black',
        backgroundColor: 'rgba(255,0,0,0.3)'
      }
    ]
  };
  public lineChartOptions: ChartOptions<'line'> = {
    responsive: false
  };
  public lineChartLegend = true;

  user:any
  role:any
  roles:any[]=[]
  
  constructor(
    private programService:ProgramService,
    private notificationService:NotificationService,
    private toastrService:ToastrService,
      config: NgbModalConfig,
      private lsService:LocalStorageService,
    private modalService: NgbModal) {
     config.backdrop = 'static';
     config.keyboard = false;
     }
  
    ngOnInit(){
  
      this.getAll()
      this.getRappels()
 this.user=this.lsService.get(GlobalName.userName)
    this.roles=this.user.roles
    }
  
     
  
    getAll(){
      this.programService.getProfessorCurrentWeekPrograms().subscribe((res:any)=>{
        this.data=res.data
      },
      (err:any)=>{
        AppErrorShow.showError("Tableau de bord enseignants",err)

      })
    }
    getRappels(){
      this.notificationService.getAll().subscribe((res:any)=>{
        this.rappels=res.data
      },
      (err:any)=>{
        AppErrorShow.showError("Tableau de bord enseignants",err)

      })
    }

    showDetails(ev?:any){
      this.rappelSelected=ev
      this.modalService.open(this.addContent)
    }
}
